export const TESSA_LICENSE_TYPES_ROUTE_PATH = '/tessa/license-types';
export const TESSA_ENVIRONMENT_AVAILABILITY_ROUTE_PATH =
  '/tessa/environment-availability';
export const TESSA_ENVIRONMENT_KEY_QUERY_PARAM = 'key';
export const TESSA_ENVIRONMENT_NAME_QUERY_PARAM = 'name';
export const TESSA_FILES_ROUTE_PATH = '/tessa/files';
export const TESSA_FILE_COMPONENT_QUERY_PARAM = 'component';
export const TESSA_FILE_ENVIRONMENT_KEY_QUERY_PARAM = 'environmentKey';
export const TESSA_FILE_ENVIRONMENT_KEY_PATTERN = /^[A-Z][A-Z0-9]{1,7}$/;
export const TESSA_OBO_ASSERTION_HEADER = 'x-tessa-assertion';
export const TESSA_FILE_COMPONENTS = ['EA'] as const;

export type TessaFileComponent = (typeof TESSA_FILE_COMPONENTS)[number];

export function isTessaFileComponent(
  value: string | undefined,
): value is TessaFileComponent {
  const components: readonly (string | undefined)[] = TESSA_FILE_COMPONENTS;
  return components.includes(value);
}
